import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class NotificationsHttpUtil {

  public static prepareParamsHistory(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    if (params.showHistory) {
      urlParams.append('showHistory', params.showHistory);
    }
    if (params.pageSize) {
      urlParams.append('pageSize', params.pageSize);
    }
    if (params.pageNumber || params.pageNumber === 0) {
      urlParams.append('pageNumber', params.pageNumber);
    }
    return urlParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/notifications/notifications.util.ts